import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import HorizontalRateChart, {
	HorizontalRateChartProps,
} from '@components/report/chart/horizontal-rate-chart/HorizontalRateChart';
import ColoredSection from '@components/report/colored-section/ColoredSection';

import ReportCard from '@components/report/report-card/ReportCard';

import { containerClass, headContainerClass } from './style.css';

export interface ContentTtProps {
	bannerHashtags?: string[];
	contentViewPerLength?: HorizontalRateChartProps;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const ContentTt = ({
	contentViewPerLength,

	isLoading,
	isError,
	lackOfPermission,
	...props
}: ContentTtProps) => {
	const { t } = useTranslation('infReportTiktok');
	const status = { isLoading, isError, lackOfPermission };

	const bannerHashtags =
		isLoading || isError
			? new Array(5).fill('-')
			: lackOfPermission
			? new Array(5).fill('example')
			: props.bannerHashtags && props.bannerHashtags.length > 0
			? props.bannerHashtags
			: t('features.report.section-content.tt.content-tt.banner-hashtags.no-data');

	const isValidHashtags = Array.isArray(bannerHashtags) && bannerHashtags.length > 0;

	const bannerHashtagsString = isValidHashtags
		? bannerHashtags.map((item) => `#${item}`).join(', ')
		: bannerHashtags;

	const contentLengthChartBase: HorizontalRateChartProps = {
		desc: (
			<>
				<Trans
					t={t}
					i18nKey="features.report.section-content.tt.content-tt.content-type.content-view-per-length.description"
					components={[
						<span key="1"> - </span>,
						<span key="2">
							{t(
								'features.report.section-content.tt.content-tt.content-type.content-view-per-length.default',
							)}
						</span>,
						<span key="3">
							{t(
								'features.report.section-content.tt.content-tt.content-type.content-view-per-length.high',
							)}
						</span>,
					]}
				/>
			</>
		),
		subDesc: t(
			'features.report.section-content.tt.content-tt.content-type.content-view-per-length.sub-description',
		),
		data: [
			{
				label: t(
					'features.report.section-content.tt.content-tt.content-type.content-view-per-length.0-15s',
				),
				value: t(
					'features.report.section-content.tt.content-tt.content-type.content-view-per-length.default',
				),
				valuePercentage: 0,
			},
			{
				label: t(
					'features.report.section-content.tt.content-tt.content-type.content-view-per-length.15-60s',
				),
				value: t(
					'features.report.section-content.tt.content-tt.content-type.content-view-per-length.default',
				),
				valuePercentage: 0,
			},
			{
				label: t(
					'features.report.section-content.tt.content-tt.content-type.content-view-per-length.60-180s',
				),
				value: t(
					'features.report.section-content.tt.content-tt.content-type.content-view-per-length.default',
				),
				valuePercentage: 0,
			},
			{
				label: t(
					'features.report.section-content.tt.content-tt.content-type.content-view-per-length.180s-600s',
				),
				value: t(
					'features.report.section-content.tt.content-tt.content-type.content-view-per-length.default',
				),
				valuePercentage: 0,
			},
		],
	};

	return (
		<div className={containerClass}>
			<div className={headContainerClass}>
				<ColoredSection
					tooltip={t(
						'features.report.section-content.tt.content-tt.banner-hashtags.tooltip',
					)}
					{...status}
				>
					<Trans
						t={t}
						i18nKey="features.report.section-content.tt.content-tt.banner-hashtags.description"
						components={
							isValidHashtags
								? [<span key={'hashtags'}>{bannerHashtagsString}</span>]
								: [<>{bannerHashtagsString}</>]
						}
					/>
					{/* 많이 사용된 주요 해시태그 5가지는 <span>{bannerHashtagsString}</span> 입니다. */}
				</ColoredSection>

				<ReportCard
					label={t('features.report.section-content.tt.content-tt.content-type.label')}
					tooltip={t(
						'features.report.section-content.tt.content-tt.content-type.tooltip',
					)}
					lackOfPermission={lackOfPermission}
					height={230}
					align="horizontal"
				>
					<HorizontalRateChart
						{...contentLengthChartBase}
						align="horizontal"
						{...(!contentViewPerLength?.data || contentViewPerLength?.data?.length === 0
							? contentLengthChartBase
							: contentViewPerLength)}
						{...status}
					/>
				</ReportCard>
			</div>
		</div>
	);
};

export default ContentTt;
